/*global WeixinJSBridge, wx*/
/* eslint-disable no-unused-vars */

/**
 * @author caienlei <caienlei>
 * @global platform                              - 判断客户端
 * @func goProduct                               - 跳转详情页
 * @func goAppWallet                             - 跳转客户端我的钱包
 * @func goActivity                              - 跳转活动页
 * @func goHome                                  - 跳转客户端首页
 * @func isLogin                                 - 判断登录态
 * @func doLogin                                 - 登录的方法
 * @func shareInitApp                            - 注册客户端分享(被动)
 * @func shareOpenApp                            - 打开客户端分享(主动)
 */

/** @global */
let _uA = navigator.userAgent.toLowerCase()

/**
 * platform 商城平台判断
 * @property {boolean} platform.isApp            - 小米商城安卓客户端
 * @property {boolean} platform.isIOSApp         - 小米商城苹果客户端
 * @property {boolean} platform.isMiniprogram    - 小米商城微信小程序
 * @property {boolean} platform.isMiuiBrowser    - 小米手机miui浏览器
 * @property {boolean} platform.isWeixin         - 微信webview
 */

let platform = {}

platform.isApp = (function () {
  if (typeof WE !== 'undefined' && _uA.indexOf('xiaomi/miuibrowser/4.3/shop') !== -1 && _uA.indexOf('iphone') === -1) {
    return true
  } else {
    return false
  }
})()

platform.isIOSApp = (function () {
  if (/xiaomi/i.test(_uA) && /iphone/i.test(_uA)) {
    return true
  } else {
    return false
  }
})()

platform.isMiuiBrowser = (function () {
  if (/xiaomi\/miuibrowser/i.test(_uA)) {
    return true
  } else {
    return false
  }
})()

platform.isWeixin = (function () {
  if (/micromessenger/i.test(_uA)) {
    return true
  } else {
    return false
  }
})()

platform.isMiniprogram = false

function miniProgramReady() {
  platform.isMiniprogram = !!(window.__wxjs_environment === 'miniprogram')
}

if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
  document.addEventListener('WeixinJSBridgeReady', miniProgramReady, false)
} else {
  miniProgramReady()
}

/**
 * 跳转小米商城单品详情页
 * @param {string} pid - 产品id.
 */
function goProduct(pid) {
  let xiaomiProductPath = {
    'path': 'ShopPlugin://com.xiaomi.shop2.plugin.goodsdetail.GoodsDetailFragment?pluginId=101',
    'extra': {
      'commodityId': pid
    }
  }
  let xiaomiMiUrl = `//m.mi.com/commodity/detail/${pid}`
  let xiaomiMiniPath = `/pages/product/index?id=${pid}`
  if (platform.isApp) window.WE.trigger('show_plugin', JSON.stringify(xiaomiProductPath))
  if (platform.isIOSApp) window.WE.trigger('show_plugin', encodeURIComponent(JSON.stringify(xiaomiProductPath)))
  if (platform.isMiniprogram) {
    try {
      wx.miniProgram.navigateTo({
        url: xiaomiMiniPath
      })
    } catch (e) {
      console.error('检查是否已经引用 https://res.wx.qq.com/open/js/jweixin-1.6.0.js')
    }
  }
  if (!platform.isApp && !platform.isIOSApp && !platform.isMiniprogram) window.top.location.href = xiaomiMiUrl
}

/**
 * 跳转小米商城我的钱包
 */
function goAppWallet() {
  let pathName = platform.isIOSApp ? 'MyWalletFragment' : 'MyWalletNewFragment'
  let xiaomiWalletPath = {
    'path': `ShopPlugin://com.xiaomi.shop.plugin.my.${pathName}?pluginId=129`,
    'extra': {}
  }
  if (platform.isApp) window.WE.trigger('show_plugin', JSON.stringify(xiaomiWalletPath))
  if (platform.isIOSApp) window.WE.trigger('show_plugin', encodeURIComponent(JSON.stringify(xiaomiWalletPath)))
}

/**
 * 跳转小米商城活动页面
 * @param {string} id   - 活动id.
 */
function goActivity(id) {
  let xiaomiActivityPath = {
    "path": "ShopPlugin://com.xiaomi.shop2.plugin.hdchannel.RootFragment?pluginId=15102",
    "extra": {
      "extra_url": "http://api.m.mi.com/v1/home/activity_page",
      "extra_ver": id.toString()
    }
  }
  if (platform.isApp) window.WE.trigger('show_plugin', JSON.stringify(xiaomiActivityPath))
  if (platform.isIOSApp) window.WE.trigger('show_plugin', encodeURIComponent(JSON.stringify(xiaomiActivityPath)))
  if (!platform.isApp && !platform.isIOSApp && !platform.isMiniprogram) window.top.location.href = `//s1.mi.com/m/app/hd/index.html?id=${id}`
}

/**
 * 跳转小米商城首页
 */
function goHome() {
  if (platform.isApp || platform.isIOSApp) {
    window.WE.trigger('gohome', null)
    return
  }

  window.top.location.href = "https://m.mi.com"
}

/**
 * 小米商城登录回调
 * @callback _loginCallback
 */
function _loginCallback() {
  window.top.location.reload()
}

/**
 * 返回小米商城登录状态
 * @returns {boolean}
 */
function isLogin() {
  if (document.cookie.indexOf('cUserId') !== -1) {
    return true
  } else {
    return false
  }
}

/**
 * 小米商城登录方法
 */
function doLogin() {
  if (platform.isApp) {
    window.WE.trigger('login', null)
  } else {
    window.top.location.href = `//i.huodong.mi.com/site/login?redirectUrl=${encodeURIComponent(location.href)}`
  }
}

/**
 * 在小米商城客户端中注册分享内容
 * 用户点击右上角更多选项触发分享
 *
 * @param {Object} data - 分享内容.
 *
 * @property {String} data.poster                         - 海报图片下载.
 * @property {String} data.poster.img_url                 - 尺寸不限带二维码的海报图片.
 *
 * @property {String} data.cx_v3                          - 分享到小米Lite(小程序卡片).
 * @property {String} data.cx_v3.wechat_friend            - 好友.
 * @property {String} data.cx_v3.wechat_friend.title      - 标题.
 * @property {String} data.cx_v3.wechat_friend.img_url    - 715x577卡片图.
 * @property {String} data.cx_v3.wechat_friend.share_url  - 小程序链接.
 * @property {String} data.cx_v3.wechat_moments           - 朋友圈.
 * @property {String} data.cx_v3.wechat_moments.img_url   - 尺寸不限带二维码的海报.
 *
 * @property {String} data.h5_v3                          - 分享H5链接形式.
 * @property {String} data.h5_v3.weibo                    - 微博.
 * @property {String} data.h5_v3.weibo.content            - 标题.
 * @property {String} data.h5_v3.weibo.img_url            - 海报比例不限.
 * @property {String} data.h5_v3.weibo.share_url          - 链接.
 * @property {String} data.h5_v3.wechat_friend            - 微信好友.
 * @property {String} data.h5_v3.wechat_friend.title      - 标题.
 * @property {String} data.h5_v3.wechat_friend.content    - 副标题.
 * @property {String} data.h5_v3.wechat_friend.img_url    - 120x120小图.
 * @property {String} data.h5_v3.wechat_friend.share_url  - 链接.
 * @property {String} data.h5_v3.wechat_moments           - 微信朋友圈.
 * @property {String} data.h5_v3.wechat_moments.title     - 标题.
 * @property {String} data.h5_v3.wechat_moments.img_url   - 120x120小图.
 * @property {String} data.h5_v3.wechat_moments.share_url - 链接.
 * @property {String} data.h5_v3.qq_friend                - qq.
 * @property {String} data.h5_v3.qq_friend.title          - 标题.
 * @property {String} data.h5_v3.qq_friend.content        - 副标题.
 * @property {String} data.h5_v3.qq_friend.img_url        - 120x120小图.
 * @property {String} data.h5_v3.qq_friend.share_url      - 链接.
 * @property {String} data.h5_v3.qq_moments               - qzone.
 * @property {String} data.h5_v3.qq_moments.title         - 标题.
 * @property {String} data.h5_v3.qq_moments.content       - 副标题.
 * @property {String} data.h5_v3.qq_moments.img_url       - 120x120小图.
 * @property {String} data.h5_v3.qq_moments.share_url     - 链接.
 * @property {String} data.h5_v3.share_url                - 链接.
 */
function shareInitApp(data) {
  let resD = JSON.stringify(data)
  if (platform.isIOSApp) {
    resD = encodeURIComponent(resD)
  }
  window.WE.trigger('share_init', resD)
}

/**
 * 呼起小米商城客户端分享弹层
 * @param {Object} data - 分享内容.
 */
function shareOpenApp(data) {
  let resD = JSON.stringify(data)
  if (platform.isIOSApp) {
    resD = encodeURIComponent(resD)
  }
  window.WE.trigger('share_open', resD)
}

/* eslint-disable no-unused-vars */
export {
  shareInitApp,
  shareOpenApp,
  platform,
  goAppWallet,
  goHome,
  goActivity,
  goProduct
}
/* eslint-disable no-unused-vars */